import { ChangeEvent, forwardRef } from "react"
import { Checkbox } from "@gogoro/go-design"
import classnames from "classnames"

import { CheckboxGroupProps, CheckboxOption } from "./CheckboxGroupProps"

import styles from "./styles.module.scss"

const CheckboxGroup = (
  {
    name,
    options = [],
    onChange = () => {},
    value: selectedValue,
    error,
    disabled,
    horizontal = true,
    className,
  }: CheckboxGroupProps,
  ref: any,
) => {
  const isVertical = !horizontal

  return (
    <div className={classnames(className, { [styles["checkbox-container--horizontal"]]: horizontal })}>
      {options?.map(
        ({ label, value, subContent, disabled: optionDisabled, ...restProps }: CheckboxOption, index: number) => {
          const checked = Array.isArray(selectedValue) ? selectedValue?.includes(value) : selectedValue === value
          const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
            const checked = e.target.checked
            if (Array.isArray(selectedValue)) {
              let currentValue = checked ? [...selectedValue, value] : selectedValue.filter((v) => v !== value)

              onChange(currentValue, e)
            } else {
              onChange(checked ? value : null, e)
            }
          }

          return (
            <div
              className={classnames(styles["option-container"], {
                [styles["option-container--horizontal"]]: horizontal,
                [styles["error"]]: error,
              })}
              key={index}>
              <Checkbox
                ref={ref}
                {...restProps}
                checked={checked}
                onChange={handleOnChange}
                name={name}
                disabled={optionDisabled || disabled}>
                {label}
              </Checkbox>
              {isVertical && <div className={styles["sub-content"]}>{subContent}</div>}
            </div>
          )
        },
      )}
    </div>
  )
}

export default forwardRef(CheckboxGroup)
